module.exports = __webpack_public_path__ + "static/media/cat.0d740fbd.svg";